























import { FilterItem } from '@/interfaces/filter-items';
import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import RuleServices from '@/services/rule';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class Job1 extends mixins(DictMixin, PageMixin) {
  bread = [{ name: '决策库' }, { name: '陪跑记录' }];
  trailSrv = new RuleServices();
  list: any[] = [];

  created() {
    this.init();
    this.getList();
  }

  async getList(params?: any) {
    this.loading = true;
    let query = this.$route.query || {};
    let res = await this.trailSrv.trailList({ ...params, ...query, page: this.page, limit: this.limit });
    this.list = res.list;
    this.total = res.totalCount;
    this.loading = false;
  }

  filterItems: FilterItem[] = [];
  init() {
    if (!this.DICT_ALERT_LEVEL) {
      setTimeout(() => {
        this.init();
      }, 100);
    } else {
      this.filterItems = [
        { label: '决策名称', key: 'ruleName', type: 'input' },
        { label: '决策集名称', key: 'ruleSetName', type: 'input' },
        { label: '决策大类', key: 'ruleFirstLevel', type: 'select', options: this.DICT_JOURNEY_SCENE },
        { label: '决策中类', key: 'ruleSecondLevel', type: 'select', options: this.DICT_JOURNEY_SUB_SCENE },
        { label: '决策小类', key: 'ruleThirdLevel', type: 'select', options: this.DICT_JOURNEY_SCENE_STEP }
      ];
    }
  }

  @Watch('$route')
  onRouteChange() {
    let path = this.$route.path;
    if(path != '/decision/trail') return false;
    this.getList();
  }

  columns = [
    { title: '决策名称', dataIndex: 'ruleName' },
    { title: '决策集名称', dataIndex: 'ruleSetName' },
    {
      title: '决策大类',
      dataIndex: 'ruleFirstLevel',
      customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SCENE', text)
    },
    { title: '陪跑预警件数', dataIndex: 'alertCount' },
    { title: '陪跑操作人', dataIndex: 'createUser' },
    { title: '操作时间', dataIndex: 'createTime' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
}
